import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors } from '@lib/selectors';
import { getSonarObjectTypeId } from '@sonar-software/sonar-ts-lib';
import { QuickAdd } from '@ui/general';
import { ViewForm } from './ViewForm';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useEffect, useRef } from 'react';
import { useAction, useAsyncState, useOnUnmount } from '@hooks';
const createViewSelectors = createAsyncSelectors((state) => state.core.dataDictionary.views.post);
export const CreateView = ({ onFinish, queryParams }) => {
    const { data, isReceived, isRequested } = useAsyncState(createViewSelectors);
    const createView = useAction(coreActions.requestPostCoreDataDictionaryViews);
    const resetCreate = useAction(coreActions.resetPostCoreDataDictionaryViews);
    const nameRef = useRef('');
    useOnUnmount(resetCreate);
    const onFinishRef = useRef(onFinish);
    onFinishRef.current = onFinish;
    useEffect(() => {
        if (isReceived && data) {
            onFinishRef.current(data.viewId, nameRef.current);
        }
    }, [data, isReceived]);
    return (React.createElement(QuickAdd, { form: ViewForm, onSubmit: (viewName) => {
            var _a, _b, _c;
            nameRef.current = viewName;
            createView({
                applicationId: queryParams.applicationId,
                columns: (_a = queryParams.columns) !== null && _a !== void 0 ? _a : '',
                complianceCategory: queryParams.complianceCategory,
                filter: (_b = queryParams.filters) !== null && _b !== void 0 ? _b : '',
                ordering: (_c = queryParams.ordering) !== null && _c !== void 0 ? _c : '',
                sonarObjectId: queryParams.sonarObjectId,
                sonarObjectTypeId: queryParams.sonarObjectType ?
                    getSonarObjectTypeId(queryParams.sonarObjectType) :
                    undefined,
                tagId: queryParams.tagId,
                viewName: viewName === null || viewName === void 0 ? void 0 : viewName.trim()
            });
        }, processing: isRequested, toggleProps: { id: 'save-filters-new-view-button' }, typeLabel: COPY_SPECIFIC.VIEW }));
};
